import { getEmailField, getPhoneNumberField } from '@lender/utils';

export const ContactType = {
  PERSON: 'Person',
  COMPANY: 'Company',
};

export const CONTACT_TYPE_OPTIONS = [
  { value: ContactType.PERSON, label: 'Person' },
  { value: ContactType.COMPANY, label: 'Company' },
];

const ContactLifecycleStage = {
  LEAD: 'Lead',
  PROSPECT: 'Prospect',
  ACTIVE_BORROWER: 'ActiveBorrower',
  PAST_CLIENT: 'PastClient',
  REFERRAL: 'Referral',
  DO_NOT_CONTACT: 'DoNotContact',
};

export const ContactLifecycleStageLabel = {
  [ContactLifecycleStage.LEAD]: 'Lead',
  [ContactLifecycleStage.PROSPECT]: 'Prospect',
  [ContactLifecycleStage.ACTIVE_BORROWER]: 'Active Borrower',
  [ContactLifecycleStage.PAST_CLIENT]: 'Past Client',
  [ContactLifecycleStage.REFERRAL]: 'Referral',
  [ContactLifecycleStage.DO_NOT_CONTACT]: 'Do Not Contact',
};

export const ContactLifecycleStageColor = {
  [ContactLifecycleStage.LEAD]: 'BLUE',
  [ContactLifecycleStage.PROSPECT]: 'ORANGE',
  [ContactLifecycleStage.ACTIVE_BORROWER]: 'GREEN',
  [ContactLifecycleStage.PAST_CLIENT]: 'GRAY',
  [ContactLifecycleStage.REFERRAL]: 'PURPLE',
  [ContactLifecycleStage.DO_NOT_CONTACT]: 'RED',
};

export const ActivityType = {
  NOTE_ADDED: 'NoteAdded',
  NOTE_EDITED: 'NoteEdited',
  NOTE_DELETED: 'NoteDeleted',
  EMAIL_SENT: 'EmailSent',
  EMAIL_RECEIVED: 'EmailReceived',
  CALL_MADE: 'CallMade',
  CALL_RECEIVED: 'CallReceived',
  SMS_SENT: 'SmsSent',
  SMS_RECEIVED: 'SmsReceived',
  MEETING_HELD: 'MeetingHeld',
  TASK_COMPLETED: 'TaskCompleted',
  LEAD_CREATED: 'LeadCreated',
  APPLICATION_CREATED: 'ApplicationCreated',
  LIFECYCLE_CHANGED: 'LifecycleChanged',
  TAG_ASSIGNED: 'TagAssigned',
  TAG_REMOVED: 'TagRemoved',
  OWNER_UNASSIGNED: 'OwnerUnassigned',
  CUSTOM: 'Custom',
};

export const LIFECYCLE_STAGE_OPTIONS = [
  { name: 'Lead', value: ContactLifecycleStage.LEAD },
  { name: 'Prospect', value: ContactLifecycleStage.PROSPECT },
  { name: 'Active Borrower', value: ContactLifecycleStage.ACTIVE_BORROWER },
  { name: 'Past Client', value: ContactLifecycleStage.PAST_CLIENT },
  { name: 'Referral', value: ContactLifecycleStage.REFERRAL },
  { name: 'Do Not Contact', value: ContactLifecycleStage.DO_NOT_CONTACT },
];

const PreferredContactMethod = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  SMS: 'Sms',
  MAIL: 'Mail',
};

export const PreferredContactMethodLabel = {
  [PreferredContactMethod.EMAIL]: 'Email',
  [PreferredContactMethod.PHONE]: 'Phone',
  [PreferredContactMethod.SMS]: 'SMS',
  [PreferredContactMethod.MAIL]: 'Mail',
};

export const PREFERRED_CONTACT_METHOD_OPTIONS = [
  { name: 'Email', value: PreferredContactMethod.EMAIL },
  { name: 'Phone', value: PreferredContactMethod.PHONE },
  { name: 'SMS', value: PreferredContactMethod.SMS },
  { name: 'Mail', value: PreferredContactMethod.MAIL },
];

const ContactTaskStatus = {
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
};

export const CLOSED_CONTACT_TASK_STATUSES = [
  ContactTaskStatus.COMPLETED,
  ContactTaskStatus.CANCELED,
];

export const UNKNOWN_USER_LABEL = 'Unknown';

// Shared stable identity for "no items", so a fallback never hands a fresh array to a memoized
// consumer and forces a re-render.
export const EMPTY_ARRAY = [];

export const CRM_CONTACT_EMAIL_METADATA_KEY = 'ContactId';

export const CONTACT_SEARCH_DEBOUNCE_MS = 400;

// MUI's default clear-button label is "Clear", which reads as "discard what I typed" — the meaning
// it carries on every other picker in the app. On the owner pickers the button unassigns a person
// from the record, so both surfaces relabel it.
export const OWNER_CLEAR_TEXT = 'Remove owner';

export const OWNER_EMPTY_PLACEHOLDER = 'Add owner';

export const SPEED_TO_LEAD_SLA_STATE = {
  ON_TRACK: 'ON_TRACK',
  AT_RISK: 'AT_RISK',
  BREACHED: 'BREACHED',
};

export const EMAIL_FIELD_SCHEMA = getEmailField({ isRequired: false });

export const PHONE_FIELD_SCHEMA = getPhoneNumberField({ isRequired: false });
